import {
    getEligiblePrintMpvIds,
    getEligibleServiceMpvIds,
} from '@99designs/design-services-common';
import { useVistaFeatureFlag } from '@99designs/experiments';

// Determines enrollment into the freelance capacity overflow feature gate if a customer meets the required criteria:
// https://console.statsig.com/5Yx4xlMFVM9VTFvZaUwBnI/gates/design_services_capacity_overflow
export function useOverflowFeatureFlag(
    serviceMpvId: string,
    printMpvId: string,
    requestType: string | undefined,
    workId: string
) {
    // Get eligible service and print MPV IDs from shared overflow products mapping
    const eligibleServiceMpvIds = getEligibleServiceMpvIds();
    const eligiblePrintMpvIds = getEligiblePrintMpvIds();

    // Determine if we should check overflow based on requestType and serviceMpvId
    const shouldCheckOverflow =
        requestType === 'Standard' && eligibleServiceMpvIds.includes(serviceMpvId);

    return useVistaFeatureFlag('design_services_capacity_overflow', [
        { value: serviceMpvId, oneOf: eligibleServiceMpvIds },
        {
            value: printMpvId,
            oneOf: eligiblePrintMpvIds,
            anyCase: true,
        },
        { value: shouldCheckOverflow, must: true },
        { value: workId, must: '' },
    ]);
}
